<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>

                <CCardBody>
                    <RestaurantsTabLinks />

                    <ImportPage
                        :id="entity.id"
                        type="restaurant"
                        :show-terminal="entity.delivery_terminal_id ? true : false" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import ImportPage from '@/components/import/ImportPage';

    export default {
        components: {
            RestaurantsTabLinks,
            ImportPage,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;

                const [error, result] = await to(this.axios.get(`/restaurants/${id}`));

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка загрузки ресторана.');
                }

                this.entity = result.data;
            },
        },
    };
</script>
